<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      :moreSearchVisible="true"
      permpisionsQuery=""
    >
      <div slot="hasExc" slot-scope="prop">
        <el-checkbox label="有" name="type" v-model="prop.form.hasExc" />
      </div>
<!--      <div slot="disposeMyOrder" slot-scope="prop">-->
<!--        <el-checkbox label="待我处理" name="type" v-model="prop.form.disposeMyOrder" />-->
<!--      </div>-->
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  addDayForDate,
} from '@qx/utils/index';
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import {mapState} from 'vuex';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderExpenseStatusOptions: [], // 订单费用状态
        orderStateOptions: [], // 订单状态
        orderTypeOptions: [], // 订单类型
        vehicleClassOptions: [], // 车辆种类
        orgIdOptions: [],
        amountFlagOptions: [], // 预付款
        sortValueOptions: [], // 订单排序
        arrivePaymentStateOptions: [], // 到付款
        isNeedBillOptions: [], // 票据要求
        form: [
          { // 订单号码
            label: '订单号码',
            value: 'orderIds',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'DependTime',
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 订单创建时间
            label: '创建时间',
            value: 'createDate',
            type: 'date',
            placeholder: '请选择创建时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 订单费用状态
            label: '订单费用状态',
            value: 'orderExpenseStatus',
            type: 'select',
            placeholder: '请选择订单费用状态',
          },
          { // 司机名称
            label: '司机名称',
            value: 'carUserName',
            type: 'input',
            placeholder: '请输入司机名称',
          },
          { // 司机手机
            label: '司机手机',
            value: 'carUserPhone',
            type: 'input',
            placeholder: '请输入司机手机',
          },
          { // 线路名称
            label: '线路名称',
            value: 'lineKey',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆种类',
          },
          { // 归属部门
            label: '归属部门',
            value: 'orgId',
            type: 'select',
            default: [],
            placeholder: '请选择归属部门',
          },
          { // 录入人员
            label: '录入人员',
            value: 'opName',
            type: 'input',
            placeholder: '请输入录入人员',
          },
          { // 订单状态
            label: '订单状态',
            value: 'orderState',
            type: 'select',
            default: -1,
            placeholder: '请选择订单状态',
          },
          { // 订单类型
            label: '订单类型',
            value: 'orderType',
            type: 'select',
            default: -1,
            placeholder: '请选择订单类型',
          },
          { // 订单类别
            label: '订单类别',
            value: 'isHis',
            type: 'select',
            default: 0,
            placeholder: '请选择订单类别',
            options: [
              {
                label: '在途',
                value: 0,
              },
              {
                label: '历史',
                value: 1,
              },
            ],
          },
          { // 客户单号
            label: '客户单号',
            value: 'customNumber',
            type: 'input',
            placeholder: '请输入客户单号',
          },
          { // 承运方
            label: '承运方',
            value: 'carrier',
            type: 'input',
            placeholder: '请输入承运方',
          },
          { // 预付款
            label: '预付款',
            value: 'amountFlag',
            type: 'select',
            default: -1,
            placeholder: '请选择预付款',
          },
          { // 到付款
            label: '到付款',
            value: 'arrivePaymentState',
            type: 'select',
            default: -1,
            placeholder: '请选择到付款',
          },
          { // 有无异常
            label: '有无异常',
            value: 'hasExc',
            default: false,
            slot: true,
          },
          // {
          //   label: '    ',
          //   value: 'doneState',
          //   type: 'checkbox',
          //   hide: false,
          //   options: [
          //     {
          //       label: '费用待完善',
          //       value: 'undone',
          //     },
          //     {
          //       label: '费用已完善',
          //       value: 'done',
          //     },
          //   ],
          // },
          // {
          //   label: '    ',
          //   value: 'reviewedState',
          //   type: 'checkbox',
          //   hide: false,
          //   options: [
          //     {
          //       label: '费用待审核/上传',
          //       value: 'unreviewed',
          //     },
          //     {
          //       label: '费用已审核',
          //       value: 'reviewed',
          //     },
          //   ],
          // },
          // { // 待我处理
          //   label: '待我处理',
          //   value: 'disposeMyOrder',
          //   default: false,
          //   slot: true,
          // },
          // { // 订单排序
          //   label: '订单排序',
          //   value: 'sortValue',
          //   type: 'select',
          //   default: 1,
          //   placeholder: '请选择排序方式',
          //   onChange: (val) => {
          //     this.$refs.searchBox.setVal('createDate', ['', '']);
          //     this.$refs.searchBox.setVal('DependTime', ['', '']);
          //     当前发车时间默认值统一由 setDefalutDate 设置为3天前。
          //   },
          // },
          // { // 票据要求
          //   label: '票据要求',
          //   value: 'isNeedBill',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请选择票据要求',
          // },

        ],
      },
    };
  },
  methods: {
    setDefalutDate () {
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'default',
        value: [this.formatDate(addDayForDate(null, -3)), ''],
        names: ['DependTime'],
      });
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
        searchBoxData.beginDependTime = this.formatDate(searchBoxData.DependTime[0]);
        searchBoxData.endDependTime = this.formatDate(searchBoxData.DependTime[1]);
        delete searchBoxData.DependTime;
      }
      // 订单创建时间
      if (searchBoxData.createDate && searchBoxData.createDate.length > 0) {
        searchBoxData.beginOrderTime = this.formatDate(searchBoxData.createDate[0]);
        searchBoxData.endOrderTime = this.formatDate(searchBoxData.createDate[1]);
        delete searchBoxData.createDate;
      }
      // 处理时间
      if (searchBoxData.ProblemDealTime && searchBoxData.ProblemDealTime.length > 0) {
        searchBoxData.beginProblemDealTime = this.formatDate(searchBoxData.ProblemDealTime[0]);
        searchBoxData.endProblemDealTime = this.formatDate(searchBoxData.ProblemDealTime[1]);
        delete searchBoxData.ProblemDealTime;
      }
      this.$refs.tableBox.saveSearchBoxData({
        vehicleClassArr: -1,
        // undone: searchBoxData.doneState.indexOf('undone') !== -1 ? 1 : 0,
        // done: searchBoxData.doneState.indexOf('done') !== -1 ? 1 : 0,
        // unreviewed: searchBoxData.reviewedState.indexOf('unreviewed') !== -1 ? 1 : 0,
        // reviewed: searchBoxData.reviewedState.indexOf('reviewed') !== -1 ? 1 : 0,
        ...searchBoxData,
      });
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息
    }),
  },
  async created () {
    if (this.userInfo.staffTFInfo.tenantId === 2483 || this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.setFormAttrVal({
        form: this.searchBoxData,
        attr: 'hide',
        value: false,
        names: ['reviewedState', 'doneState'],
      });
    } else {
      this.setFormAttrVal({
        form: this.searchBoxData,
        // attr: 'hide',
        value: true,
        names: ['reviewedState', 'doneState'],
      });
    }
    this.setDefalutDate();
    const enumsList = await getEnumList({
      codeType: 'ORDER_STATE,ORDER_TYPE,VEHICLE_CLASS,AMOUNT_FLAG,IS_NEED_BILL,ORDER_EXPENSE_STATUS',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.orderExpenseStatusOptions = [ // 订单费用状态
      ...safeEnum(5),
    ];
    this.searchBoxData.orderStateOptions = [ // 订单状态
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(0),
    ];
    this.searchBoxData.orderTypeOptions = [ // 订单类型
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(1),
    ];
    this.searchBoxData.vehicleClassOptions = [ // 车辆种类
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(2),
    ];
    this.searchBoxData.amountFlagOptions = [ // 预付款
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(3),
      {
        label: '待我处理',
        value: 99,
      },
    ];
    this.searchBoxData.sortValueOptions = [ // 订单排序
      {
        label: '创建时间',
        value: 1,
      },
      {
        label: '发车时间',
        value: 0,
      },
    ];
    this.searchBoxData.arrivePaymentStateOptions = [ // 到付款
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(3),
      {
        label: '待我处理',
        value: 99,
      },
    ];
    this.searchBoxData.isNeedBillOptions = [ // 票据要求
      {
        label: '全部',
        value: -1,
      },
      ...safeEnum(4),
    ];
    this.searchBoxData.orgIdOptions = await getDepartmentAllList();
  },
};
</script>

<style lang="scss" scoped>
</style>
